// Chakra imports
import { Box, useColorModeValue } from '@chakra-ui/react';
import Footer from 'components/footer/Footer.js';
// Layout components
import Sidebar, { SidebarResponsive } from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState, useEffect } from 'react';
import SupportNotification from 'components/support/SupportNotification';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'routes.js';
import { userController } from 'lib/user';

// Custom Chakra theme
export default function Dashboard(props) {

	const { ...rest } = props;
	const mobileMenuBg = useColorModeValue('white', 'navy.800');
	const mobileMenuShadow = useColorModeValue(
		'14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
		'14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
	);

	// Load app settings into localStorage so sidebar can react to them
	const { getSingleRecord } = userController();
	useEffect(() => {
		const controller = new AbortController();
		getSingleRecord('/user/app-settings/general', controller.signal)
			.then(res => {
				const existing = JSON.parse(localStorage.getItem('app_settings') || '{}');
				localStorage.setItem('app_settings', JSON.stringify({
					...existing,
					whatsapp_chat_enabled: res.data.whatsapp_chat_enabled,
					whatsapp_support_visible: res.data.whatsapp_support_visible,
				}));
			})
			.catch(() => {});
		return () => controller.abort();
	}, []);
	const [ toggleSidebar, setToggleSidebar ] = useState(false);
	// functions for changing the states from components
	const getRoute = () => {
		return window.location.pathname !== '/user/full-screen-maps';
	};
	const getActiveRouteArray = (routes) => {
		for (let i = 0; i < routes.length; i++) {
			if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
				return routes[i];
			}
		}
	};

	const getRoutes = (routes) => {
		const { userDetail } = userController();
		const { getUser } = userDetail();

		return routes.map((prop, key) => {
			if (prop.type === 'sidebarDropdown') {
				return getRoutes(prop.items);
			}
			if (prop.layout === '/user') {
				if (getActiveRouteArray(routes) && !getActiveRouteArray(routes).roles.includes(getUser.role)) {
					return <Redirect to={prop.layout + '/dashboard'} />;
				}
				return <Route exact path={prop.layout + prop.path} component={prop.component} key={key} />;
			}
			if (prop.collapse) {
				return getRoutes(prop.items);
			}
			if (prop.category) {
				return getRoutes(prop.items);
			} else {
				return null;
			}
		});
	};
	document.documentElement.dir = 'ltr';
	return (
		<Box
		className='eaudience'
		>
			<SupportNotification />
			<Box>
				<SidebarContext.Provider
					value={{
						toggleSidebar,
						setToggleSidebar
					}}>
					<Sidebar routes={routes} display='none' {...rest} />
					<Box
						float='right'
						minHeight='100vh'
						height='100%'
						overflow='auto'
						position='relative'
						maxHeight='100%'
						w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
						maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
						transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
						transitionDuration='.2s, .2s, .35s'
						transitionProperty='top, bottom, width'
						transitionTimingFunction='linear, linear, ease'>
						<Box
							display={{ base: 'flex', xl: 'none' }}
							position='fixed'
							top='16px'
							left='16px'
							zIndex='100'
							bg={mobileMenuBg}
							borderRadius='12px'
							boxShadow={mobileMenuShadow}
							p='10px'>
							<SidebarResponsive routes={routes} />
						</Box>

						{getRoute() ? (
							<Box mx='auto' p={{ base: '20px', md: '30px' }} pe='20px' minH='100vh' pt={{ base: '70px', xl: '30px' }}>
								<Switch>
									{getRoutes(routes)}
									<Redirect from='/' to='/user/dashboard' />
								</Switch>
							</Box>
						) : null}
						<Box>
							<Footer />
						</Box>
					</Box>
				</SidebarContext.Provider>
			</Box>
		</Box>
	);
}
